import axios from 'axios'
import config from '@/config'
import { ServicePackageRequest, ServicePackageResponse } from '@/model'

const fetchPrice = async (servicePackages: ServicePackageRequest): Promise<ServicePackageResponse[]> => {
  const response = await axios.post(`${config.API_URL}/api/prices`, servicePackages)
  return response.data.servicePackages.map((s: any) => ServicePackageResponse.of(s, response.data.disclaimers, response.data.allowanceAmount))
}

export {
  fetchPrice
}
